import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'

const { testimonials } = require('@/assets.v2/js/pagesSite.js')
const { header } = require('@/assets.v2/js/header.js')
const { productsPilotForm } = require('@/assets.v2/js/productsPilotForm.js')

import { AdjustWrapper } from '@/analytics/adjust'
import { Mixpanel } from '@/analytics/mixpanel'
import { initAB } from '@/services/ab'
import { applyNavbarButtons } from '@/pages-site-v2/helpers/navbar'
import { initAudioWidgets } from '@/assets.v2/js/audioWidget'
import { initCarouselStaticPages } from '@/models/carousel'
import {
  applyPartnerDiscountText,
  applyPricingContent,
  getLocalCreator,
  hasPartnerAttribution,
  initPartnerDiscountDismissHandlers,
  loadCreator,
  resetPartnerDiscountDismissState,
  updatePartnerDiscountBody,
} from '@/pages-site-v2/partnerDiscount'

export function initPageSiteV2(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', function () {
    header()
    testimonials()
    initAudioWidgets()
    initCarouselStaticPages()
  })
}

export async function onPageLoad(): Promise<void> {
  await initAB()

  if (hasPartnerAttribution()) {
    await loadCreator()
    const creator = getLocalCreator()
    if (creator) {
      resetPartnerDiscountDismissState()
      updatePartnerDiscountBody()
      initPartnerDiscountDismissHandlers()
      applyPartnerDiscountText(creator)
      applyPricingContent(creator)
    }
  }
  Mixpanel.pageView()

  const currentPath = window.location.pathname
  const pathSegments = currentPath.split('/').filter(Boolean)

  const isHome = currentPath === '/'
  const isLandingPage = pathSegments[0] === 'lp' && pathSegments.length === 2
  if (isHome || isLandingPage) {
    await AdjustWrapper.trackPageViewHomepage()
  }

  trackCTAClicks()
  applyNavbarButtons()

  if (window.location.pathname.startsWith('/pilot/')) {
    productsPilotForm()
  }
}

function trackCTAClicks(): void {
  const storeLinks = document.querySelectorAll(
    '.apps__link',
  ) as NodeListOf<HTMLElement>
  storeLinks.forEach((link) => {
    link.addEventListener('click', () =>
      Mixpanel.trackHomeCTAClick('store_link', link.id),
    )
  })

  const reviewTabs = document.querySelectorAll(
    '.blockquote-people-slider__button',
  ) as NodeListOf<HTMLElement>
  reviewTabs.forEach((tab) => {
    tab.addEventListener('click', () =>
      Mixpanel.trackHomeCTAClick('review', tab.id),
    )
  })

  const pilotInterestedLink = document.querySelector(
    '.pilot-hero__button',
  ) as HTMLElement
  if (pilotInterestedLink) {
    pilotInterestedLink.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('top_interested'),
    )
  }

  const pilotInterestedFormButton = document.querySelector(
    '#ic-button-yes',
  ) as HTMLElement
  if (pilotInterestedFormButton) {
    pilotInterestedFormButton.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('interest_form_submit', 'yes'),
    )
  }

  const pilotNotInterestedFormButton = document.querySelector(
    '#ic-button-no',
  ) as HTMLElement
  if (pilotNotInterestedFormButton) {
    pilotNotInterestedFormButton.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('interest_form_submit', 'no'),
    )
  }
}
